import { ActionType, Reducer, getType } from 'typesafe-actions';
import { MeasurementGlobalState, defaultMeasurementState } from './types';
import * as measurementActions from './actions';

type MeasurementActions = ActionType<typeof measurementActions>;
export const measurementReducer: Reducer<
  MeasurementGlobalState,
  MeasurementActions
> = (
  state: MeasurementGlobalState = defaultMeasurementState(),
  action: MeasurementActions,
): MeasurementGlobalState => {
  switch (action.type) {
    case getType(measurementActions.measuredValuesLoaded): {
      return {
        ...state,
        measuredValues: action.payload,
      };
    }
    case getType(measurementActions.importFinished): {
      return {
        ...state,
        measuredValues: [],
        readFile: undefined,
      };
    }
    case getType(measurementActions.importRestarted): {
      return {
        ...state,
        measuredValues: [],
      };
    }
    case getType(measurementActions.importCancelled): {
      return {
        ...state,
        measuredValues: [],
        readFile: undefined,
        file: undefined,
        pdfFile: undefined,
      };
    }
    case getType(measurementActions.fileRead): {
      return {
        ...state,
        readFile: action.payload,
      };
    }
    case getType(measurementActions.fileLoaded): {
      return {
        ...state,
        file: action.payload
          ? {
              fileName: action.payload.fileName,
              data: action.payload.data,
            }
          : undefined,
      };
    }
    case getType(measurementActions.pdfFileLoaded): {
      return {
        ...state,
        pdfFile: action.payload
          ? {
              fileName: action.payload.fileName,
              data: action.payload.data,
            }
          : null,
      };
    }
    default: {
      return state;
    }
  }
};
